import { render, staticRenderFns } from "./AddNewAdmin.vue?vue&type=template&id=a597a50c&"
import script from "./AddNewAdmin.vue?vue&type=script&lang=ts&"
export * from "./AddNewAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports